import en from "./resources/en.json";
import zh from "./resources/zh.json";
import id from "./resources/id.json";
import ms from "./resources/ms.json";
import th from "./resources/th.json";
import vi from "./resources/vi.json";
import fil from "./resources/fil.json";
import es from "./resources/es.json";
import ja from "./resources/ja.json";
import pt from "./resources/pt.json";
import ko from "./resources/ko.json";
import zh_Hant from "./resources/zh_Hant.json";
import de from "./resources/de.json";
import fr from "./resources/fr.json";
import hi from "./resources/hi.json";
import ru from "./resources/ru.json";
import bn from "./resources/bn.json";
import tr from "./resources/tr.json";

export const resources = {
    en: {
      translations: en,
    },
    en_GB: {
      translations: en,
    },
    zh: {
      translations: zh,
    },
    "zh-Hans": {
      translations: zh,
    },
    "zh-Hant": {
      translations: zh_Hant,
    },
    id: {
      translations: id,
    },
    in: {
      translations: id,
    },
    ms: {
      translations: ms,
    },
    my: {
      translations: ms,
    },
    th: {
      translations: th,
    },
    vi: {
      translations: vi,
    },
    fil: {
      translations: fil,
    },
    tl: {
      translations: fil,
    },
    es: {
      translations: es,
    },
    ja: {
      translations: ja,
    },
    pt: {
      translations: pt,
    },
    pt_PT: {
      translations: pt,
    },
    ko: {
      translations: ko,
    },
    de: {
      translations: de,
    },
    fr: {
      translations: fr,
    },
    hi: {
      translations: hi,
    },
    ru: {
      translations: ru,
    },
    bn: {
      translations: bn,
    },
    tr: {
      translations: tr,
    },
  } as const;